// 减免类型
export { ReduceType as ReduceTypeEnum } from "@/pbjs/xcommon/ticket_pb.js";
// 审批状态
export { ReduceStatus as ReduceStatusEnum } from "@/pbjs/xcommon/ticket_pb.js";
// 审批状态
export { Bool as BoolEnum } from "@/pbjs/xcommon/ticket_pb.js";
// 委外状态
export { OutSourceRange as OutSourceRangeEnum } from "@/pbjs/xcommon/enum_pb";
// 二次验证
export { TwoFactAuthRange as TwoFactAuthRangeEnum } from "@/pbjs/xcommon/enum_pb";
//  工作状态
export { UserWorkStatusRange as UserWorkStatusRangeEnum } from "@/pbjs/xcommon/enum_pb";
//  执行者类型
export { ExecType as ExecTypeEnum } from "@/pbjs/xcommon/enum_pb";
//  执行者类型
export { WarningLetterStatus as WarningLetterStatusEnum } from "@/pbjs/xcommon/ticket_pb";

//性别
export { Gender as GenderEnum } from "@/pbjs/xcommon/enum_pb";
//婚姻状态
export { MaritalStatus as MaritalStatusEnum } from "@/pbjs/xcommon/enum_pb";
//关系
export { Relationship as RelationshipEnum } from "@/pbjs/xcommon/enum_pb";
//惩罚类型
export { RewardItem as RewardItemEnum } from "@/pbjs/xcommon/enum_pb";
//惩罚 问题类型
export { RewardCategory as RewardCategoryEnum } from "@/pbjs/xcommon/enum_pb";
//是否首复贷，个人绩效
export { LoanTypeEnum as LoanTypeEnum } from "@/pbjs/xcommon/ticket_pb";
//短信push任务管理
export { PushTaskTypeEnum as PushTaskTypeEnum } from "@/pbjs/xcommon/ticket_pb";
export { StatusTypeEnum as StatusTypeEnum } from "@/pbjs/xcommon/ticket_pb";


//  拨打类型
export { CallTypeEnum as CallTypeEnumEnum } from "@/pbjs/xcommon/ticket_pb";
//  催收记录stats查询维度
export { UDDimension as UDDimensionEnum } from "@/pbjs/xcommon/ticket_pb";

